export const bindWithChunking = (channel: any, event: any, callback: any) => {
  channel.bind(event, callback);
  const events = {};

  channel.bind(`chunked-${event}`, (data: any) => {
    if (!events.hasOwnProperty(data.id)) {
      // @ts-ignore
      events[data.id] = { chunks: [], receivedFinal: false };
    }

    // @ts-ignore
    const ev = events[data.id];

    ev.chunks[data.index] = data.chunk;

    if (data.final) {
      ev.receivedFinal = true;
    }

    if (ev.receivedFinal && ev.chunks.length === Object.keys(ev.chunks).length) {
      callback(JSON.parse(ev.chunks.join('')));
      // @ts-ignore
      delete events[data.id];
    }
  });
};

export const pusherOptions = {
  forceTLS: true,
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
};
